<via-button-bar [buttonDisabled]="true"></via-button-bar>
<via-progress-bar [complete]="true"></via-progress-bar>

<div class="e-success-layout" role="main">
    <div class="e-success-message">
        <i class="fal fa-smile"></i>
        <h3>Success</h3>
        <p>
            You have completed your extraction. Your download has started and you will now be redirected
            to the <a (click)="goToDownloadsPage()">downloads</a> page, where you can track the progress of the
            extraction. You will also be notified by email once it has completed.
        </p>
    </div>
    <div class="e-action-bar">
        <via-sku-count></via-sku-count>
    </div>
</div>